import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { View, Text, Modal, Image, StyleSheet, TouchableOpacity, ScrollView, Dimensions, Share, SafeAreaView, Platform, StatusBar, ActivityIndicator, TextInput, Button } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
const { height, width, width: screenWidth } = Dimensions.get('window');
import Markdown from "react-native-markdown-display";


// codigo do info 


// codigo do info 
const RemedioDetalhes = ({ route, navigation }) => {
    const { id = null, status } = route.params || {};
    const [imovelData, setImovelData] = useState(null);
    const [remedioData, setRemedioData] = useState(null);
    const [activeSlide, setActiveSlide] = useState(0);
    const [showFullDescription, setShowFullDescription] = useState(false);

    const [peso, setPeso] = useState('');
    const [modalVisible, setModalVisible] = useState(false);
    const [resultado, setResultado] = useState(null);
    const [carregando, setCarregando] = useState(false);

    const calcularDose = async () => {
        if (!peso) return;
        setCarregando(true);

        try {
            const response = await axios.post(`https://api-doseexata.josuejuca.com/api/v1/calcular-dose/${id}?peso_paciente=${peso}`);
            setResultado(response.data);
            setModalVisible(true);
        } catch (error) {
            alert('Erro ao calcular a dose. Tente novamente.');
        } finally {
            setCarregando(false);
        }
    };

    useEffect(() => {
        // Chamada para buscar dados do imóvel pela API
        const fetchImovelData = async () => {
            try {
                const response = await axios.get(`https://api-doseexata.josuejuca.com/api/v1/medicamentos/${id}`);
                const data = response.data;
                setRemedioData(data);
            } catch (error) {
                console.error('Erro ao buscar os dados do imóvel:', error);
            }
        };
        fetchImovelData();
    }, [id]);

    const handleScroll = (event) => {
        const slide = Math.ceil(event.nativeEvent.contentOffset.x / screenWidth);
        if (slide !== activeSlide) {
            setActiveSlide(slide);
        }
    };


    if (!remedioData) {
        return (
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                <ActivityIndicator size="large" color="#004aad" />
            </View>
        );
    }

    const imagem_formula = remedioData.img_formula_url

    return (
        <SafeAreaView style={styles.safeArea}>
            <ScrollView style={styles.container}>
                <View style={styles.carouselContainer}>
                    <ScrollView
                        horizontal
                        pagingEnabled
                        showsHorizontalScrollIndicator={false}
                        onScroll={handleScroll}
                        scrollEventThrottle={16}
                        style={styles.carousel}
                    >
                        <View style={styles.imageContainer}>
                            <Image source={{ uri: remedioData.capa || 'https://juca.eu.org/img/doseexata/02/default.png' }} style={styles.image} />
                            <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
                                <Image source={require('../assets/icons/back_blue.png')} style={styles.backIcon} />
                            </TouchableOpacity>
                            <View style={styles.footer}>
                                <Text style={styles.footerText}>
                                    {activeSlide + 1}/1
                                </Text>
                            </View>
                        </View>
                    </ScrollView>
                </View>

                {/* Progresso */}
                <View style={styles.section}>
                    {/* Descrição do Progresso */}
                    <Text style={[styles.descriptionText, { color: status >= 10 ? '#004aad' : '#004aad' }]} allowFontScaling={false}> {remedioData.nome}
                    </Text>
                </View>

                {/* Preço e localização */}
                <View style={styles.section}>
                    <Text style={styles.price} allowFontScaling={false}>Informações do remedio</Text>

                    <Text style={styles.details} allowFontScaling={false}>{remedioData.nome}</Text>
                    <Text style={styles.details} allowFontScaling={false}>{remedioData.restricoes}</Text>

                </View>

                {/* Preço e localização */}
                <View style={styles.section}>
                    <Text style={styles.price} allowFontScaling={false}>Tipo do remedio</Text>

                    <Text style={styles.details} allowFontScaling={false}>{remedioData.tipo}
                    </Text>
                </View>


                {/* Orientação do Sol */}
                <View style={styles.section}>
                    <Text style={styles.label} allowFontScaling={false}>Como usar (Formula / Macete)</Text>


                    {imagem_formula ? (
                        <Image
                            source={{ uri: imagem_formula || 'https://juca.eu.org/img/doseexata/default.png' }}
                            style={styles.image_formula}
                        />
                    ) : (
                        <View style={styles.section}>
                            <Text style={{ textAlign: 'center', color: 'gray' }}>Imagem não disponível</Text>
                        </View>
                    )}


                    <View style={styles.orientationBox}>
                        <Text style={styles.orientationText} allowFontScaling={false}></Text>
                        <Text style={styles.orientationText} allowFontScaling={false}>{remedioData.formula_base}</Text>
                    </View>
                </View>


                {/* Preço e localização */}
                <View style={styles.section}>
                    <Text style={styles.price} allowFontScaling={false}>Observação</Text>

                    <Text style={styles.detailsRed} allowFontScaling={false}>{remedioData.obs}
                    </Text>
                </View>

                <View style={{ padding: 20, alignItems: 'center' }}>
                    <Text style={{ fontSize: 22, fontWeight: 'bold', marginBottom: 15, color: '#004aad'}} allowFontScaling={false}>
                        Calcular Dose
                    </Text>

                    <TextInput
                        style={{
                            borderWidth: 1,
                            borderColor: '#ddd',
                            borderRadius: 25,
                            padding: 12,
                            fontSize: width * 0.035,
                            backgroundColor: '#F5F5F5',
                            textAlign: 'center',
                            width: '100%',
                        }}
                        placeholder="Peso da criança (kg)"
                        keyboardType="numeric"
                        value={peso}
                        onChangeText={setPeso}
                        allowFontScaling={false}
                    />

                    <TouchableOpacity
                        onPress={calcularDose}
                        disabled={!peso || carregando}
                        style={{
                            marginTop: 10,
                            backgroundColor: !peso || carregando ? '#A9A9A9' : '#004aad',
                            paddingVertical: 12,
                            borderRadius: 25,
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        {carregando ? (
                            <ActivityIndicator color="#fff" />
                        ) : (
                            <Text style={{ color: '#fff', fontSize: width * 0.035, fontWeight: 'bold' }} allowFontScaling={false}>
                                {carregando ? 'Calculando...' : 'Calcular'}
                            </Text>
                        )}
                    </TouchableOpacity>

                    {/* Modal para exibir o resultado */}
                    <Modal
                        visible={modalVisible}
                        transparent={true}
                        animationType="slide"
                        onRequestClose={() => setModalVisible(false)}
                    >
                        <View style={{
                            flex: 1,
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        }}>
                            <View style={{
                                width: '85%',
                                backgroundColor: '#fff',
                                padding: 20,
                                borderRadius: 15,
                                alignItems: 'center',
                                elevation: 5,
                            }}>
                                {resultado && (
                                    <>
                                        <Text style={{ fontSize: 18, fontWeight: 'bold', textAlign: 'center', marginBottom: 10 }} allowFontScaling={false}>
                                            Com o peso de <Text style={{ color: '#004aad' }}>{peso}KG</Text>, a dose indicada é:
                                        </Text>
                                        <Text style={{ fontSize: 16, color: '#004aad', fontWeight: 'bold' }} allowFontScaling={false}>
                                            {resultado.dose} {resultado.unidade} a cada {resultado.frequencia}
                                        </Text>
                                        <Text style={{ fontSize: 14, color: 'red', marginTop: 10 }} allowFontScaling={false}>
                                            Obs: {resultado.observacoes}
                                        </Text>
                                    </>
                                )}
                                <TouchableOpacity
                                    onPress={() => setModalVisible(false)}
                                    style={{
                                        marginTop: 20,
                                        backgroundColor: '#004aad',
                                        paddingVertical: 10,
                                        paddingHorizontal: 20,
                                        borderRadius: 25,
                                    }}
                                >
                                    <Text style={{ color: '#fff', fontSize: 16 }} allowFontScaling={false}>
                                        Fechar
                                    </Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </Modal>
                </View>
            </ScrollView>
        </SafeAreaView>
    );
};

const styles = StyleSheet.create({

    // testes
    // Ajuste para o container do carrossel ocupar 100% da largura e altura proporcionais
    carouselContainer: {
        width: screenWidth,  // Garante 100% da largura da tela
        height: screenWidth * 0.75,  // Proporção ajustada
        marginHorizontal: 0,  // Remove margens horizontais
        paddingHorizontal: 0,  // Remove padding horizontal
        marginBottom: 10,
    },

    imageContainer: {
        width: screenWidth,  // Cada imagem vai ocupar 100% da largura da tela
        height: '100%',  // O container da imagem vai ocupar toda a altura do carrossel
        margin: 0,  // Remove qualquer margem
        padding: 0,  // Remove qualquer padding
    },

    image: {
        width: '100%',
        height: '100%',
        resizeMode: 'cover',  // Garante que a imagem preencha o container sem ser cortada
        backgroundColor: '#F5F5F5',  // Fundo cinza claro
    },

    image_formula: {
        width: screenWidth * 0.9, // 90% da largura da tela
        height: screenWidth * 0.6, // Ajuste de altura proporcional
        alignSelf: 'center', // Centraliza horizontalmente
        resizeMode: 'contain', // Evita cortes na imagem
        marginVertical: 10, // Espaço entre elementos
    },

    carousel: {
        flex: 1,
        backgroundColor: "black"
    },

    // testes

    // Parte do progresso:
    progressContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: height * 0.02,
    },
    progressBar: {
        flexDirection: 'row',
        flex: 1,
    },
    progressSegment: {
        height: 8,
        flex: 1,
        marginHorizontal: 2,
        borderRadius: 4,
    },
    activeProgressSegment: {
        flexDirection: 'row',
        flex: 1,
        borderRadius: 4,
        overflow: 'hidden', // Para que as metades fiquem dentro da barra
    },
    progressHalf: {
        flex: 1,
        height: '100%',
    },
    statusIcon: {
        width: 34,
        height: 34,
        marginLeft: width * 0.02,
    },
    descriptionText: {
        fontSize: width * 0.035,
        textAlign: 'center',
        fontWeight: 'bold',
        marginBottom: height * 0.02,
    },

    // Fim parte do progresso

    // detalhes
    price: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#1F2024',
        marginBottom: Platform.select({
            ios: 10,
            android: 8,
            web: 8,
        }),
    },
    location: {
        fontSize: 16,
        color: '#004aad',
        marginBottom: Platform.select({
            ios: 10,
            android: 8,
            web: 8,
        }),
    },
    details: {
        fontSize: 16,
        color: '#1F2024',
        marginBottom: Platform.select({
            ios: 5,
            android: 4,
            web: 4
        }),
    },
    detailsRed: {
        fontSize: 16,
        color: 'red',
        marginBottom: Platform.select({
            ios: 5,
            android: 4,
            web: 4
        }),
    },
    secondarydetails: {
        fontSize: 16,
        color: '#71727A',
        marginBottom: Platform.select({
            ios: 5,
            android: 4,
            web: 4
        }),
    },
    // Para o conteúdo ocupar 90% e ficar centralizado, ajuste o section
    section: {
        width: '90%',  // Ocupa 90% da largura da tela
        alignSelf: 'center',  // Centraliza o conteúdo sem usar marginLeft        
        marginBottom: Platform.select({
            ios: width * 0.05,
            android: width * 0.06,
            web: width * 0.06,
        }),
    },
    label: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 10,
        color: '#333',
    },
    // Orientação do Sol - Ajustes para Web
    orientationBox: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#004aad',
        padding: Platform.select({
            ios: 15,
            android: 12,
            web: 10, // Aumenta o padding para web
        }),
        borderRadius: 25, // Mantém o arredondado
        marginBottom: 20, // Espaçamento extra abaixo do campo
    },
    orientationText: {
        fontSize: Platform.select({
            ios: 16,
            android: 16,
            web: 18, // Aumenta o tamanho da fonte para web
        }),
        fontWeight: 'bold',
        color: '#FFFFFF',
        marginRight: 10, // Espaçamento entre o texto e o ícone
    },
    icon: {
        width: 30,
        height: 30,
        tintColor: '#FFFFFF',
        marginLeft: 10, // Espaçamento entre o ícone e o texto
    },

    tagContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    tag: {
        backgroundColor: '#E9E9E9',
        paddingVertical: Platform.select({
            ios: 5,
            android: 4,
        }),
        paddingHorizontal: 10,
        borderRadius: 8,
        marginRight: 10,
        marginBottom: 10,
    },
    tagText: {
        fontSize: 14,
        color: '#1F2024',
    },
    description: {
        fontSize: 16,
        color: '#71727A',
    },
    moreText: {
        color: '#004aad',
        fontWeight: 'bold',
    },

    // fim detalhes

    // estilo do avaliador
    safeArea: {
        flex: 1,
        backgroundColor: '#F5F5F5',
        paddingTop: Platform.select({
            android: StatusBar.currentHeight + 1, // Para Android
            ios: 4, // Para iOS | default 4 
            web: 0, // Maior espaçamento no topo para Web | default 20
        }),
    },
    // estilo das fotos
    container: {
        backgroundColor: '#F5F5F5',
    },

    backButton: {
        position: 'absolute',
        top: 20,
        left: 15,
        zIndex: 2,
    },
    backIcon: {
        width: 24, // Ajusta a largura da seta
        height: 24, // Ajusta a altura da seta
    },
    shareButton: {
        position: 'absolute',
        top: 20,
        right: 15,
        zIndex: 2,
    },
    shareIcon: {
        width: 24,
        height: 24,
    },
    footer: {
        position: 'absolute',
        bottom: 15,
        right: 15,
        backgroundColor: '#FFFFFF', // Fundo branco
        borderRadius: 12,
        paddingHorizontal: 10,
        paddingVertical: 5,
    },
    footerText: {
        color: '#000', // Texto preto
        fontSize: 14,
    },
});

export default RemedioDetalhes;